import { render, staticRenderFns } from "./TherapyNDLandingPage.vue?vue&type=template&id=6c1f60be"
import script from "./TherapyNDLandingPage.vue?vue&type=script&lang=js"
export * from "./TherapyNDLandingPage.vue?vue&type=script&lang=js"
import style0 from "./TherapyNDLandingPage.vue?vue&type=style&index=0&id=6c1f60be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports